export enum LegendStyle {
    Line,
    Circle
}

export type LegendItem = {
  key: string;
  name: string;
  color: string;
  style: LegendStyle;
  visible: boolean;
  index: number;
};
